var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 7C8.71875 7.16667 8.6875 7.32792 8.625 7.48375C8.5625 7.64042 8.47917 7.77083 8.375 7.875L2.625 13.625C2.39583 13.8542 2.10417 13.9688 1.75 13.9688C1.39583 13.9688 1.10417 13.8542 0.875 13.625C0.645833 13.3958 0.53125 13.1042 0.53125 12.75C0.53125 12.3958 0.645833 12.1042 0.875 11.875L5.75 7L0.875 2.125C0.645833 1.89583 0.53125 1.60417 0.53125 1.25C0.53125 0.895833 0.645833 0.604168 0.875 0.375001C1.10417 0.145835 1.39583 0.031249 1.75 0.031249C2.10417 0.031249 2.39583 0.145835 2.625 0.375001L8.375 6.125C8.5 6.25 8.58833 6.38542 8.64 6.53125C8.6925 6.67708 8.71875 6.83333 8.71875 7Z",
    fill: "#33303C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.601e53f9b1b46e275a66bc55c0ca6dcf.svg";
export { ForwardRef as ReactComponent };